import { forwardRef } from "react";
import { IconPropsType, Ref } from "./IconPropsType";

const Eye = forwardRef<Ref, IconPropsType>(
  ({ color = "currentColor", size, className, onClick }, ref) => (
    <svg
      ref={ref}
      className={className}
      onClick={onClick}
      width={size ?? 24}
      height={size ?? 24}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth={1.7}
      strokeLinecap="round"
      strokeLinejoin="round"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7-10-7-10-7z" />
      <circle cx="12" cy="12" r="3" />
    </svg>
  ),
);

export default Eye;
